import { useEffect, useRef } from 'react';
import { FieldValues } from 'react-hook-form';

/**
 * Re-seeds a react-hook-form instance with fresh defaults the moment a modal opens,
 * without resetting on every re-render while it stays open (which would clobber in-progress edits).
 */
export const useResetOnOpen = <TFieldValues extends FieldValues>(
  open: boolean,
  reset: (values: TFieldValues) => void,
  values: TFieldValues,
) => {
  const prevOpenRef = useRef(false);

  useEffect(() => {
    if (open && !prevOpenRef.current) {
      reset(values);
    }
    prevOpenRef.current = open;
  }, [open, values, reset]);
};
